"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterPrettyPrintIndented = void 0;
var uom_1 = require("uom");
var property_1 = require("@promaster-sdk/property");
var lib_cjs_1 = require("ts-exhaustive-check/lib-cjs");
var filter_type_inferrer_1 = require("../type-inference/filter-type-inferrer");
var expr_type_1 = require("../type-inference/expr-type");
function filterPrettyPrintIndented(messages, indentationDepth, indentionString, f, 
// unitsFormat: {
//   readonly [key: string]: UnitFormat.UnitFormat;
// } = UnitsFormat
unitsFormat, unitLookup) {
    var e = f.ast;
    if (e === null) {
        return "";
    }
    var typeMap = filter_type_inferrer_1.inferTypeMap(f);
    return visit(e, indentationDepth, indentionString, messages, typeMap, unitsFormat, unitLookup);
}
exports.filterPrettyPrintIndented = filterPrettyPrintIndented;
function visit(e, indentationDepth, indentionString, messages, typeMap, unitsFormat, unitLookup) {
    var innerVisit = function (indent, expr) {
        return visit(expr, indent, indentionString, messages, typeMap, unitsFormat, unitLookup);
    };
    switch (e.type) {
        case "AndExpr": {
            var s = "";
            for (var _i = 0, _a = e.children; _i < _a.length; _i++) {
                var child = _a[_i];
                s += innerVisit(indentationDepth, child);
                if (child !== e.children[e.children.length - 1]) {
                    s += "\n" + _generateIndention(indentationDepth + 1, indentionString) + messages.andMessage() + "\n";
                }
            }
            return s;
        }
        case "ComparisonExpr": {
            var left = innerVisit(indentationDepth, e.leftValue);
            var right = innerVisit(indentationDepth, e.rightValue);
            return (_generateIndention(indentationDepth, indentionString) +
                messages.comparisionOperationMessage(e.operationType, left, right));
        }
        case "EmptyExpr": {
            return "";
        }
        case "EqualsExpr": {
            var left = innerVisit(indentationDepth, e.leftValue);
            var builder = [];
            for (var _b = 0, _c = e.rightValueRanges; _b < _c.length; _b++) {
                var range = _c[_b];
                var rangeMessage = innerVisit(indentationDepth, range);
                builder.push(rangeMessage);
                if (range !== e.rightValueRanges[e.rightValueRanges.length - 1]) {
                    builder.push(messages.orMessage());
                }
            }
            var buf = "";
            var reversed = _reversed(builder);
            for (var i = 0; i < reversed.length; i++) {
                var x = reversed[i];
                buf += x;
                if (i < reversed.length - 1) {
                    buf += " ";
                }
            }
            var joined = buf;
            return (_generateIndention(indentationDepth, indentionString) +
                messages.equalsOperationMessage(e.operationType, left, joined));
        }
        case "IdentifierExpr": {
            return messages.propertyNameMessage(e.name);
        }
        case "OrExpr": {
            var s = "";
            for (var _d = 0, _e = e.children; _d < _e.length; _d++) {
                var child = _e[_d];
                s += innerVisit(indentationDepth + 1, child);
                if (child !== e.children[e.children.length - 1]) {
                    s += "\n" + _generateIndention(indentationDepth, indentionString) + messages.orMessage() + "\n";
                }
            }
            return s;
        }
        case "ValueExpr": {
            var type = typeMap.get(e);
            if (type && type.exprTypeEnum === expr_type_1.ExprTypeEnum.Property && type.propertyName !== null) {
                return messages.propertyValueMessage(type.propertyName, e.parsed);
            }
            else if (e.parsed.type === "integer") {
                var integer = property_1.PropertyValue.getInteger(e.parsed);
                var cultureFormatted = integer ? integer.toString() : "";
                return cultureFormatted;
            }
            else if (e.parsed.type === "amount") {
                var split = e.unParsed.split(":");
                if (split.length === 2) {
                    var unit = uom_1.Serialize.stringToUnit(split[1], unitLookup);
                    if (unit) {
                        var unitFormat = uom_1.UnitFormat.getUnitFormat(unit, unitsFormat);
                        if (unitFormat) {
                            return split[0] + " " + unitFormat.label;
                        }
                        else {
                            return split[0];
                        }
                    }
                    else {
                        return split[0];
                    }
                }
                else {
                    return split[0];
                }
            }
            else if (e.parsed.type === "text") {
                return property_1.PropertyValue.getText(e.parsed) || "";
            }
            break;
        }
        case "ValueRangeExpr": {
            var min = innerVisit(indentationDepth, e.min);
            var max = innerVisit(indentationDepth, e.max);
            return min === max ? min : messages.rangeMessage(min, max);
        }
        case "NullExpr": {
            return messages.nullMessage();
        }
        case "AddExpr": {
            return innerVisit(indentationDepth, e.left) + " " + (e.operationType === "add" ? "+" : "-") + " " + innerVisit(indentationDepth, e.right);
        }
        case "MulExpr": {
            return innerVisit(indentationDepth, e.left) + " " + (e.operationType === "multiply" ? "*" : "/") + " " + innerVisit(indentationDepth, e.right);
        }
        case "UnaryExpr": {
            return "-" + innerVisit(indentationDepth, e.value);
        }
        default: {
            lib_cjs_1.exhaustiveCheck(e, true);
        }
    }
    return "";
}
// Returns a reversed copy
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _reversed(array) {
    return array.slice().reverse();
}
function _generateIndention(indentationDepth, indentionString) {
    var b = "";
    for (var i = 0; i < indentationDepth; i++) {
        b += indentionString;
    }
    return b;
}
//# sourceMappingURL=filter-pretty-print-indented.js.map